export const FIND_CURRENT_USER_LOCATION_PENDING =
  'FIND_CURRENT_USER_LOCATION_PENDING'
export const FIND_SUBLOCATION_BYID_SUCCESS = 'FIND_SUBLOCATION_BYID_SUCCESS'
export const CREATE_A_NEW_LOCATION_PENDING = 'CREATE_A_NEW_LOCATION_PENDING'
export const CREATE_A_NEW_LOCATION_SUCCESS = 'CREATE_A_NEW_LOCATION_SUCCESS'
export const RESET_TO_INIT_STATE = 'RESET_TO_INIT_STATE'
